<template>
  <div class="text-center">
    <h5 v-if="!hideTitle" class="text-h5 font-weight-bold">
      Start Your Review
    </h5>
    <p
      v-if="!hideTitle"
      class="text-body-2 grey--text text--darken-2"
    >
      Upload your reference files to get started.
    </p>
    <upload-page-placeholder
      prompt="Drag &amp; drop your reference files"
      multiple
      @input="onOpenModal"
    />
  </div>
</template>

<script>
import UploadPagePlaceholder from '@/components/Common/UploadPagePlaceholder';
import { mapActions } from 'vuex';
import { v4 as createUUID } from 'uuid';

export default {
  name: 'UploadReferencesPagePlaceholder',
  components: { UploadPagePlaceholder },
  props: { hideTitle: { type: Boolean, default: false } },
  methods: {
    ...mapActions({
      openUploadModal: 'uploadReferences/openModal',
    }),
    onOpenModal(files) {
      this.openUploadModal({
        files: files.map((file) => ({ id: createUUID(), file })),
      });
    },
  },
};
</script>
